import { useEffect, useRef } from "react"
import MitIdImage from "~/images/mitid.png"
import AuthenticityTokenInput from "../AuthenticityTokenInput"
export interface MitIdProps {
  identityProviderId: string
  appSwitchReturnUrl?: string
  appPlatform?: string
  token?: string
}
export default function MitId({
  token,
  identityProviderId,
  appSwitchReturnUrl,
  appPlatform
}: MitIdProps) {
  const formRef = useRef<HTMLFormElement>(null)

  const submitForm = () => {
    if (token && window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(token))
    } else {
      formRef?.current?.submit()
    }
  }

  useEffect(() => {
    submitForm()
  }, [])

  return (
    <form
      ref={formRef}
      action={`/auth/saml/${identityProviderId}`}
      method="post"
      role="form"
      className="w-full flex justify-center items-center"
      data-testid="mitid-form"
    >
      <AuthenticityTokenInput />
      {Boolean(appSwitchReturnUrl) && (
        <input
          type="hidden"
          name="app_switch_return_url"
          value={appSwitchReturnUrl}
        />
      )}
      {Boolean(appPlatform) && (
        <input type="hidden" name="app_platform" value={appPlatform} />
      )}
      <div className="flex flex-col py-16 items-center">
        <p className="text-2xl font-bold mb-5">Vælg log ind metode</p>
        <button
          type="submit"
          className="px-5 py-16 border border-info-300 rounded-3xl hover:opacity-80"
        >
          <img src={MitIdImage} alt="MitId" className="w-32" />
        </button>
      </div>
    </form>
  )
}
